import React from 'react';

import AppProviders from '../../../app/providers/AppProviders';
import TouzenLegacyRoutes from '../routes/TouzenLegacyRoutes';

const TouzenLegacyApp = () => {
  return (
    <AppProviders useAuth={true}>
      <TouzenLegacyRoutes />
    </AppProviders>
  );
};

export default TouzenLegacyApp;
